import React from "react";

const ImageCarousel = () => {
  // Replace these with your actual image paths
  const images = [
    "/images/CustomizedServiceDetailImg/img1.png",
    "/images/CustomizedServiceDetailImg/img2.png",
    "/images/CustomizedServiceDetailImg/img3.png",
    "/images/CustomizedServiceDetailImg/img4.png",
    "/images/CustomizedServiceDetailImg/img5.png",
    "/images/CustomizedServiceDetailImg/img6.png",
  ];

  return (
    <div className="w-full bg-white py-10">
      {/* Container hides overflow */}
      <div className="relative flex overflow-hidden group">
        {/* The Animated Wrapper (Flex container) */}
        {/* We repeat the content twice to ensure a seamless loop */}
        <div className="flex animate-infinite-scroll whitespace-nowrap group-hover:[animation-play-state:paused]">
          {/* First set of images */}
          {images.map((src, index) => (
            <div key={`set1-${index}`} className="flex-shrink-0 px-2 sm:px-4">
              <img
                src={src}
                alt={`Scientific slide ${index}`}
                className="h-40 w-64 sm:h-56 sm:w-80 object-cover rounded-2xl shadow-sm transition-transform duration-300 hover:scale-105"
              />
            </div>
          ))}

          {/* Second identical set (The "Twin") */}
          {images.map((src, index) => (
            <div key={`set2-${index}`} className="flex-shrink-0 px-2 sm:px-4">
              <img
                src={src}
                alt={`Scientific slide ${index}`}
                className="h-40 w-64 sm:h-56 sm:w-80 object-cover rounded-2xl shadow-sm transition-transform duration-300 hover:scale-105"
              />
            </div>
          ))}
        </div>

        {/* Optional: Gradient Overlays for a "fade" effect on edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-white to-transparent"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-white to-transparent"></div>
      </div>
    </div>
  );
};

export default ImageCarousel;
